/**
 * Countdown-Timer und Zeitformatierung für Gebäude-Karten.
 * Ausgelagert aus BuildingCard.ts für Timer-Lifecycle-Management.
 */

export function formatTime(sec: number): string {
  if (sec <= 0) return 'fertig';
  if (sec < 60) return `${Math.ceil(sec)}s`;
  if (sec < 3600) return `${Math.floor(sec / 60)}m ${Math.ceil(sec % 60)}s`;
  const h = Math.floor(sec / 3600);
  const m = Math.ceil((sec % 3600) / 60);
  return `${h}h ${m}m`;
}

export function startCountdown(
  el: HTMLElement, until: string, level: number,
  onDone?: () => void,
  cleanups?: (() => void)[],
): void {
  const endMs = new Date(until).getTime();
  const update = () => {
    const remain = (endMs - Date.now()) / 1000;
    if (remain <= 0) {
      el.style.color = '#6f6';
      el.textContent = `\u2714 Lv${level + 1} fertig`;
      clearInterval(id);
      if (onDone) setTimeout(onDone, 1200);
      return;
    }
    el.textContent = `\u2692 Lv${level} \u2192 Lv${level + 1}  ${formatTime(remain)}`;
  };
  update();
  const id = setInterval(update, 1000);
  if (cleanups) cleanups.push(() => clearInterval(id));
}
